import React from 'react';
import PremiumLayout from './PremiumLayout';
import { Box, Heading, Text, Button } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const PremiumNotFound: React.FC = () => {
  return (
    <PremiumLayout>
      <Box className="sparta-container sparta-section" py={20} textAlign="center">
        <Heading as="h1" fontSize={{ base: '5xl', md: '6xl' }} mb={4} textTransform="uppercase">
          404
        </Heading>
        <Text fontSize={{ base: 'lg', md: 'xl' }} mb={4} opacity={0.9}>
          Oops! Stránka nebyla nalezena.
        </Text>
        <Text fontSize="md" mb={8} opacity={0.8}>
          Stránka, kterou hledáte, byla pravděpodobně smazána nebo přesunuta.
        </Text>
        <Button
          as={RouterLink}
          to="/"
          size="lg"
          className="sparta-button-primary"
        >
          Zpět na úvodní stránku
        </Button>
      </Box>
    </PremiumLayout>
  );
};

export default PremiumNotFound;
